import { useLanguage } from './useLanguage'

const INS_SUPPORTED_LANGUAGES = ['fr', 'iv']

export function useIsINSEnabled() {
  const language = useLanguage()
  return INS_SUPPORTED_LANGUAGES.includes(language)
}
